export enum TabTypes {
  'region',
  'language',
}
